import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";
import api, { formatApiError } from "../../lib/api";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0C0A09] text-[#F5F0EB] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="grain-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm bg-[#171412] border border-[#2C2623] p-8"
      >
        <div className="flex items-center gap-2 mb-2">
          <Flame className="w-6 h-6 text-[#E05A36]" />
          <span className="font-display font-extrabold uppercase">Popular<span className="text-[#E05A36]">Rebelz</span></span>
        </div>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#7A7067] mb-8">Back-office access</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Admin email"
            className="w-full bg-[#0C0A09] border border-[#2C2623] focus:border-[#E05A36] outline-none px-4 py-3 text-sm transition-colors"
            data-testid="admin-email-input"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-[#0C0A09] border border-[#2C2623] focus:border-[#E05A36] outline-none px-4 py-3 text-sm transition-colors"
            data-testid="admin-password-input"
          />
          {error && <p className="text-xs text-[#E05A36] font-mono" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#E05A36] text-[#0C0A09] font-bold uppercase tracking-wider py-3.5 hover:bg-[#F06B47] active:scale-[0.98] transition-all disabled:opacity-50"
            data-testid="admin-login-submit-button"
          >
            {loading ? "Entering..." : "Enter the back office"}
          </button>
        </form>
        <a href="/" className="block text-center text-xs font-mono text-[#7A7067] hover:text-[#E05A36] mt-6 uppercase tracking-widest transition-colors" data-testid="admin-login-back-link">
          ← Back to store
        </a>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
